import React from 'react';
import './ScrollableAppWrapper.css';

const ScrollableAppWrapper = ({ children }) => {
  return (
    <div className="scrollable-app-wrapper">
      {children}
    </div>
  );
};

export default ScrollableAppWrapper;